module.exports = __webpack_public_path__ + "icon-128.png";


//////////////////
// WEBPACK FOOTER
// ../shared-components/src/assets/images/icon-128.png
// module id = 374
// module chunks = 0